import { createContext, useContext, useEffect, useState } from "react";
import { AuthStrapiContext } from "./AuthStrapiV3Context";
import { ActualLangContext } from "./ActualLangContext";
import axios from "axios";

export const ContentStaffAugmentationContext = createContext({});

export const ContentStaffAugmentationProvider = ({ children }) => {
  const { actualLang } = useContext(ActualLangContext);
  const { token } = useContext(AuthStrapiContext);

  const [loadedData, setLoadedData] = useState(false);
  const [SEOContent, setSEOContent] = useState({});

  useEffect(() => {
    setLoadedData(false);
    const url = `${process.env.REACT_APP_URL_API}/pages-staff-augmentation?_locale=${actualLang}`;
    if (token) {
      axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          setSEOContent(res.data?.SEOMetaData);
          setLoadedData(true);
        })
        .catch((err) =>
          console.log(
            `Ocurrio un error al obtener los datos de la pagina de Staff Augmentation: ${err.message}`
          )
        );
    }
  }, [actualLang, token]);
  return (
    <ContentStaffAugmentationContext.Provider value={{ loadedData, SEOContent }}>
      {children}
    </ContentStaffAugmentationContext.Provider>
  );
};